/* LIORIVE — PDP «strip» gallery (rev 2026-10-28b) (templates/product.json, desktop ≥990px), Kiton-style.
   - The photo row is sized so the name and price fit on the first screen (--lr-strip-h).
   - Arrows move one photo at a time and wrap around (after the last photo comes the first).
   - The row can be dragged with the mouse.
   - A click opens a full-screen viewer: photo at full height on ivory, round arrows that wrap,
     ×, Esc and ←/→ keys; a click inside zooms in and the photo follows the mouse.
   No library. Phones keep Dawn's own gallery. */
(function () {
  var mq = window.matchMedia('(min-width: 990px)');
  var PLUS = 'url("data:image/svg+xml,%3Csvg xmlns=\'http://www.w3.org/2000/svg\' width=\'48\' height=\'48\' viewBox=\'0 0 48 48\'%3E%3Cpath d=\'M24 9.6v28.8M38.4 24H9.6\' stroke=\'%231d1d1d\' stroke-width=\'2\' stroke-linecap=\'round\'/%3E%3C/svg%3E") 24 24, zoom-in';
  var MINUS = 'url("data:image/svg+xml,%3Csvg xmlns=\'http://www.w3.org/2000/svg\' width=\'48\' height=\'48\' viewBox=\'0 0 48 48\'%3E%3Cpath d=\'M38.4 24H9.6\' stroke=\'%231d1d1d\' stroke-width=\'2\' stroke-linecap=\'round\'/%3E%3C/svg%3E") 24 24, zoom-out';
  var ARROW = '<svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true" focusable="false"><path d="M9 5l7 7-7 7" fill="none" stroke="currentColor" stroke-width="1.5"/></svg>';

  function product() {
    var marker = document.querySelector('[data-lr-strip]');
    return marker && marker.closest('.product');
  }

  /* Photo height = what is left of the first screen once the header, the breadcrumb and the head
     (type, name, price) are counted, never below 28rem nor above 72rem. */
  function fit() {
    var p = product();
    if (!p || !mq.matches) return;
    var list = p.querySelector('.product__media-list');
    var head = p.querySelector('.lr-pdp-head');
    if (!list) return;
    var top = list.getBoundingClientRect().top + window.scrollY;
    var headH = head ? head.offsetHeight + 32 + 24 : 160; // head + its top margin + a little air
    var h = Math.round(Math.min(720, Math.max(280, window.innerHeight - top - headH)));
    document.documentElement.style.setProperty('--lr-strip-h', h + 'px');
  }

  function photos(items) {
    return items.map(function (li) { return li.querySelector('img'); }).filter(Boolean).map(function (img) {
      var src = img.currentSrc || img.src;
      return { src: src.replace(/([?&])width=\d+/, '$1width=2400'), alt: img.alt || '' };
    });
  }

  function init() {
    var p = product();
    var list = p && p.querySelector('.product__media-list');
    if (!list || list.dataset.lrStrip) return;
    list.dataset.lrStrip = '1';
    fit(); // final photo size first: the endless row measures it
    var wrap = list.parentElement;
    wrap.classList.add('lr-strip');

    function step() {
      var item = list.querySelector('.product__media-item');
      return item ? item.getBoundingClientRect().width + 4 : list.clientWidth / 4;
    }
    function max() { return list.scrollWidth - list.clientWidth; }

    /* Endless row: one copy of the photos before and one after the real ones. Whenever the row drifts
       into a copy, it jumps back by one set (invisible), so dragging or the arrows never reach an end.
       Only when the photos overflow the row. Copies carry no ids and are hidden from assistive tech. */
    var originals = Array.prototype.slice.call(list.querySelectorAll('.product__media-item'));
    var withPhoto = originals.filter(function (li) { return !li.classList.contains('lr-media--tile'); });
    var loop = false, setW = 0;
    function measureSet() {
      setW = originals.reduce(function (w, li) { return w + li.getBoundingClientRect().width + 4; }, 0);
    }
    /* The selected colour's photo (Dawn marks it .is-active, else the first one) sits in the middle. */
    function center() {
      var active = list.querySelector('.product__media-item.is-active:not(.lr-strip__clone)') || originals[0];
      var x = active.offsetLeft - list.firstElementChild.offsetLeft;
      list.scrollLeft = x - (list.clientWidth - active.offsetWidth) / 2;
    }
    measureSet();
    // A colour with one or two photos: centred, not stuck to the left with empty space beside them.
    // The endless row needs the three sets to cover the screen: one set at least two thirds of the row.
    var canLoop = false; // endless row switched off (owner, 2026-10-28: the motion felt poor)
    wrap.classList.toggle('lr-strip--few', !canLoop);
    // When every photo fits, the chosen colour's photo takes the middle place (flex order), the others
    // keep their order around it. When they overflow, the row scrolls to put it in the middle.
    var activeLi = list.querySelector('.product__media-item.is-active') || originals[0];
    var mid = Math.floor(originals.length / 2);
    if (setW <= list.clientWidth + 8) {
      var k = 0;
      originals.forEach(function (li) {
        if (li === activeLi) { li.style.order = mid; return; }
        li.style.order = k < mid ? k : k + 1;
        k++;
      });
    } else {
      originals.forEach(function (li) { li.style.order = ''; });
      center();
    }
    if (canLoop) {
      loop = true;
      function copy(li) {
        var c = li.cloneNode(true);
        c.classList.add('lr-strip__clone');
        c.setAttribute('aria-hidden', 'true');
        c.removeAttribute('id');
        c.querySelectorAll('[id]').forEach(function (n) { n.removeAttribute('id'); });
        c.querySelectorAll('a, button, [tabindex]').forEach(function (n) { n.setAttribute('tabindex', '-1'); });
        c.querySelectorAll('img').forEach(function (n) { n.loading = 'lazy'; });
        return c;
      }
      var first = originals[0];
      originals.forEach(function (li) { list.insertBefore(copy(li), first); });
      originals.forEach(function (li) { list.appendChild(copy(li)); });
      center();
      list.addEventListener('scroll', function () {
        if (list.scrollLeft < setW * 0.5) { list.scrollLeft += setW; startLeft += setW; }
        else if (list.scrollLeft > setW * 1.5) { list.scrollLeft -= setW; startLeft -= setW; }
      }, { passive: true });
      window.addEventListener('resize', function () {
        var ratio = setW ? (list.scrollLeft - setW) / setW : 0;
        measureSet();
        list.scrollLeft = setW + ratio * setW;
      });
    }
    var nav = document.createElement('div');
    nav.className = 'lr-strip__nav';
    [['prev', 'Photo précédente', -1], ['next', 'Photo suivante', 1]].forEach(function (a) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'lr-strip__arrow lr-strip__arrow--' + a[0];
      b.setAttribute('aria-label', a[1]);
      b.innerHTML = ARROW;
      b.addEventListener('click', function () {
        // Endless row: just move. Otherwise wrap around (end → first photo, start → last).
        if (loop) list.scrollBy({ left: a[2] * step(), behavior: 'smooth' });
        else if (a[2] > 0 && list.scrollLeft >= max() - 2) list.scrollTo({ left: 0, behavior: 'smooth' });
        else if (a[2] < 0 && list.scrollLeft <= 2) list.scrollTo({ left: max(), behavior: 'smooth' });
        else list.scrollBy({ left: a[2] * step(), behavior: 'smooth' });
      });
      nav.appendChild(b);
    });
    wrap.appendChild(nav);
    function sync() { nav.hidden = max() <= 2; } // every photo already visible: no arrows
    window.addEventListener('resize', sync);
    sync();

    // Drag with the mouse (touch already scrolls natively).
    var down = false, startX = 0, startLeft = 0, moved = false;
    list.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse' || e.button !== 0 || !mq.matches) return;
      down = true; moved = false; startX = e.clientX; startLeft = list.scrollLeft;
    });
    window.addEventListener('pointermove', function (e) {
      if (!down) return;
      var dx = e.clientX - startX;
      if (!moved && Math.abs(dx) > 5) { moved = true; list.classList.add('is-dragging'); }
      if (moved) { list.scrollLeft = startLeft - dx; e.preventDefault(); }
    });
    window.addEventListener('pointerup', function () {
      if (!down) return;
      down = false;
      if (moved) {
        list.classList.remove('is-dragging');
        var s = step();
        list.scrollTo({ left: Math.round(list.scrollLeft / s) * s, behavior: 'smooth' });
      }
    });
    // A click opens the viewer (instead of Dawn's modal); a drag opens nothing.
    list.addEventListener('click', function (e) {
      if (!mq.matches) return;
      e.preventDefault(); e.stopPropagation();
      if (moved) { moved = false; return; }
      var item = e.target.closest('.product__media-item');
      if (!item || item.classList.contains('lr-media--tile')) return; // the colour tile has no photo to open
      var items = Array.prototype.slice.call(list.querySelectorAll('.product__media-item:not(.lr-media--tile)'));
      var i = Math.max(0, items.indexOf(item));
      viewer(photos(withPhoto), loop ? i % withPhoto.length : i);
    }, true);
    list.addEventListener('dragstart', function (e) { e.preventDefault(); });
    fit();
  }

  /* Full-screen viewer. */
  var box, img, idx = 0, set = [], zoomed = false, opener = null;
  function viewer(list, start) {
    set = list; idx = start; opener = document.activeElement;
    if (!box) {
      box = document.createElement('div');
      box.className = 'lr-zoom';
      box.setAttribute('role', 'dialog');
      box.setAttribute('aria-modal', 'true');
      box.setAttribute('aria-label', 'Photos du produit');
      box.innerHTML =
        '<button type="button" class="lr-zoom__close" aria-label="Fermer"><svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="1.5"/></svg></button>' +
        '<button type="button" class="lr-zoom__arrow lr-zoom__arrow--prev" aria-label="Photo précédente">' + ARROW + '</button>' +
        '<div class="lr-zoom__stage"><img class="lr-zoom__img" alt=""></div>' +
        '<button type="button" class="lr-zoom__arrow lr-zoom__arrow--next" aria-label="Photo suivante">' + ARROW + '</button>' +
        '<p class="lr-zoom__count" aria-live="polite"></p>';
      document.body.appendChild(box);
      img = box.querySelector('.lr-zoom__img');
      box.querySelector('.lr-zoom__close').addEventListener('click', close);
      box.querySelector('.lr-zoom__arrow--prev').addEventListener('click', function () { go(-1); });
      box.querySelector('.lr-zoom__arrow--next').addEventListener('click', function () { go(1); });
      img.addEventListener('click', function (e) { zoom(!zoomed, e); });
      img.addEventListener('mousemove', pan);
      document.addEventListener('keydown', function (e) {
        if (!box.classList.contains('is-open')) return;
        if (e.key === 'Escape') close();
        else if (e.key === 'ArrowRight') go(1);
        else if (e.key === 'ArrowLeft') go(-1);
      });
    }
    show();
    box.classList.add('is-open');
    document.documentElement.classList.add('lr-zoom-lock');
    box.querySelector('.lr-zoom__close').focus();
  }
  function show() {
    zoom(false);
    img.src = set[idx].src;
    img.alt = set[idx].alt;
    box.querySelector('.lr-zoom__count').textContent = (idx + 1) + ' / ' + set.length;
    box.classList.toggle('is-single', set.length < 2);
  }
  function go(d) { idx = (idx + d + set.length) % set.length; show(); } // wraps around
  function zoom(on, e) {
    zoomed = on;
    box.classList.toggle('is-zoomed', on);
    img.style.cursor = on ? MINUS : PLUS;
    if (on && e) pan(e); else img.style.transformOrigin = '50% 50%';
  }
  function pan(e) {
    if (!zoomed) return;
    var r = img.getBoundingClientRect();
    var x = ((e.clientX - r.left) / r.width) * 100, y = ((e.clientY - r.top) / r.height) * 100;
    img.style.transformOrigin = x + '% ' + y + '%';
  }
  function close() {
    box.classList.remove('is-open');
    document.documentElement.classList.remove('lr-zoom-lock');
    zoom(false);
    if (opener && opener.focus) opener.focus();
  }

  /* Kiton-style details: a centred head (type, name, price), then two columns: the reading column
     (material, notes, description) and the buying column (favourite, colours, button, trust).
     The wrappers are display: contents below 990px, so phones keep the original single column. */
  function details() {
    var marker = document.querySelector('[data-lr-strip]');
    var box = marker && marker.closest('.product__info-container');
    if (!box || box.querySelector('.lr-pdp-head')) return;
    var kids = Array.prototype.slice.call(box.children);
    var head = document.createElement('div'); head.className = 'lr-pdp-head';
    var read = document.createElement('div'); read.className = 'lr-pdp-col lr-pdp-col--read';
    var buy = document.createElement('div'); buy.className = 'lr-pdp-col lr-pdp-col--buy';
    var cols = document.createElement('div'); cols.className = 'lr-pdp-cols';
    kids.forEach(function (el) {
      if (el.matches('.lr-eyebrow, .product__title, [id^="price-"], .product__tax')) head.appendChild(el);
      else if (el.matches('.lr-pdp-fav, variant-selects, .lr-trust, .lr-sib') || el.querySelector('product-form, .lr-sib')) buy.appendChild(el);
      else if (el.tagName !== 'SCRIPT') read.appendChild(el);
    });
    cols.appendChild(read); cols.appendChild(buy);
    box.insertBefore(head, box.firstChild);
    box.insertBefore(cols, head.nextSibling);
  }
  function boot() {
    if (mq.matches) details();
    init();
    fit();
    window.addEventListener('resize', fit);
    window.addEventListener('load', fit);
    // A colour change re-renders the gallery (Dawn): rebuild the arrows and drag on the new row.
    var p = product();
    var media = p && p.querySelector('.product__media-wrapper');
    // Dawn may replace the row or only its photos: once it settles, drop our copies and arrows and
    // build again, so the new colour's photo is centred among the right photos.
    var timer = null;
    function rebuild() {
      var list = media.querySelector('.product__media-list');
      if (!list) return;
      obs.disconnect();
      list.querySelectorAll('.lr-strip__clone').forEach(function (n) { n.remove(); });
      media.querySelectorAll('.lr-strip__nav').forEach(function (n) { n.remove(); });
      delete list.dataset.lrStrip;
      init();
      obs.observe(media, { childList: true, subtree: true });
    }
    var obs = new MutationObserver(function (records) {
      var ours = records.every(function (r) {
        return Array.prototype.every.call(r.addedNodes, function (n) { return n.nodeType !== 1 || n.classList.contains('lr-strip__clone') || n.classList.contains('lr-strip__nav'); });
      });
      if (ours) return;
      clearTimeout(timer);
      timer = setTimeout(rebuild, 150);
    });
    if (media) obs.observe(media, { childList: true, subtree: true });
    // Crossing the breakpoint rebuilds the page in the right order for that width.
    mq.addEventListener('change', function () { location.reload(); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
